import { z } from 'zod';
import { RecentlyViewedContentType } from '../enums';

export const CreateRecentlyViewedDto = z.object({
  contentType: z.nativeEnum(RecentlyViewedContentType),
  contentId: z.string().uuid(),
});

export type ApiCreateRecentlyViewedDto = z.infer<
  typeof CreateRecentlyViewedDto
>;
